import { useDispatch, useSelector } from 'react-redux';
import { BadgeCheck, Share2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import clx from 'classnames';
import { getCustomerProducts } from 'Containers/Settings/store/selectors';
import { modalActions } from 'Containers/Modals/store';
import useWindowSize from 'utils/useWindowSize';
import styles from './VerifiedSalonButton.module.scss';

const VerifiedSalonButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const products = useSelector(getCustomerProducts());

  if (Number(products?.badge) !== 1) return null;

  const openShare = () => {
    dispatch(modalActions.OPEN_MODAL.SUCCESS({ type: 'verifiedShareModal' }));
  };

  return (
    <button
      type="button"
      className={clx(styles.verified_button, {
        [styles.verified_button_mobile]: isMobile,
      })}
      onClick={openShare}
      aria-label={t('header.verified.aria')}
    >
      <span className={styles.medal_wrap} aria-hidden="true">
        <span className={styles.ribbon} />
        <span className={styles.medal}>
          <BadgeCheck size={14} strokeWidth={2.7} />
        </span>
      </span>
      {isMobile ? (
        <Share2 className={styles.verified_share_icon} size={14} strokeWidth={2.4} />
      ) : (
        <>
          <span className={styles.verified_text}>
            <span className={styles.verified_eyebrow}>{t('header.verified.eyebrow')}</span>
            <span className={styles.verified_name}>{t('header.verified.name')}</span>
          </span>
          <span className={styles.verified_cta}>
            <Share2 size={12} strokeWidth={2.5} />
            {t('header.verified.cta')}
          </span>
        </>
      )}
    </button>
  );
};

export default VerifiedSalonButton;
